import { api } from '@cma/app'
import {
  SharePlatformClientResourcesMutation,
  SharePlatformClientResourcesMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

interface SharePlatformClientResourcesProps {
  accountId: string
}

export function useSharePlatformClientResources({
  accountId
}: SharePlatformClientResourcesProps) {
  const queryClient = useQueryClient()

  return useMutation<
    SharePlatformClientResourcesMutation,
    Error,
    SharePlatformClientResourcesMutationVariables
  >(
    (variables) => {
      const query = gql`
        mutation SharePlatformClientResources(
          $shareTargets: [ShareTargetInput!]!
          $shareableContents: [ShareableContentInput!]!
        ) {
          sharePlatformClientResources(
            shareTargets: $shareTargets
            shareableContents: $shareableContents
          ) {
            errors
            contentShares {
              id
              createdAt
              shareableId
              shareableType
              shareableContentId
              shareableContentType
            }
          }
        }
      `

      return api<
        SharePlatformClientResourcesMutation,
        SharePlatformClientResourcesMutationVariables
      >({ query, variables })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries([
          'platformContent',
          { id: accountId }
        ])
      }
    }
  )
}
